export default class DeliveryTime {
    
    minDelivery = null
    maxDelivery = null
    minDesk = null
    maxDesk = null

    constructor(minDelivery, maxDelivery, minDesk, maxDesk) {
        this.minDelivery = minDelivery
        this.maxDelivery = maxDelivery
        this.minDesk = minDesk
        this.maxDesk = maxDesk
    }
}